import React, { Component } from 'react'
import { Modal, Select, Input, Button, List } from 'antd'

export default class SubPolicy extends Component<any, any> {
    state: any = {
        toggleCovers: false
    }
    handleCoversToggle = () => this.setState(prevState => ({ toggleCovers: !prevState.toggleCovers }))
    render() {
        const { toggleCovers } = this.state
        const {
            policy_name,
            policy_id,
            company_id,
            policy_long_name,
            policy_price,
            insurance_period,
            insuranceCaseRightParameters
        } = this.props
        const cases = {}
        if (insuranceCaseRightParameters && insuranceCaseRightParameters.length > 0)
            insuranceCaseRightParameters.forEach((cover, index) => {
                const right_name = cover.right_name ? cover.right_name : 'כיסוי כללי לפוליסה'
                if (!cases[right_name]) cases[right_name] = []
                cases[right_name].push(cover)
            })
        const covers = Object.keys(cases).map((key, index) => (
            <div key={index}>
                <strong>{key}</strong>
                <div>
                    <ul style={{ margin: 0 }}>
                        {cases[key].map(({ value, parameter_name, parameter_id }, index) => (
                            <li key={index}>
                                {parameter_name} : {value}{' '}
                                {!parameter_id ? <strong style={{ color: 'red' }}>(פרמטר לא נמצא)</strong> : ''}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        ))
        return (
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <div>
                        <div>
                            <a
                                target="_blank"
                                style={{ color: 'black', textDecoration: 'underline' }}
                                href={`/insurance/${company_id}/${policy_id}`}
                            >
                                {policy_id} | {policy_long_name || policy_name}
                            </a>
                        </div>
                        <div>
                            {insuranceCaseRightParameters.length > 0 ? (
                                <a style={{ textDecoration: 'underline' }} onClick={this.handleCoversToggle}>
                                    {toggleCovers ? 'הסתר כיסויים' : 'הצג כיסויים'}
                                </a>
                            ) : (
                                'ללא כיסויים'
                            )}
                        </div>
                    </div>
                    <div>
                        <div>
                            <strong>מחיר: </strong>
                            {policy_price}
                        </div>
                        <div>תוקף: {insurance_period}</div>
                    </div>
                </div>
                <div style={{ width: '100%' }}>{toggleCovers ? covers : ''}</div>
            </div>
        )
    }
}
